<template>
  <router-view />
  <Notification />
  <LegalNotice />
  <Debug v-if="true" />
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import LegalNotice from '@/components/LegalNotice.vue';
export default defineComponent({
  components: {
    LegalNotice,
  },
  setup() {
    const debug = ref(false);

    document.body.addEventListener('keyup', function (event) {
      if (event.ctrlKey && event.key == 'F3') {
        debug.value = !debug.value;
      }
    });

    return { debug };
  },
});
</script>
<style lang="scss">
body {
  color: $c-dark-gray !important;
  background-color: $c-off-white !important;
}

button,
.button,
button {
  width: 100%;
  display: inline-block;
  cursor: pointer;
  transition: all 0.2s;
  border-radius: 0;
  background-color: transparent;
  border: 1px solid $c-blue;
  color: $c-dark-grey;
  line-height: 1.2;
  padding: 10px;
  padding-left: 15px;
  padding-right: 15px;
  text-transform: uppercase;
  letter-spacing: 1px;

  &:hover,
  &.isExactActive {
    border-color: $c-blue;
    color: $c-blue;
  }

  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;
    &:hover {
      border-color: $c-blue;
      color: $c-dark-grey;
    }
  }
}

#app {
  //font-family: 'Exo 2', sans-serif;
  font-family: 'Geomanist';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  letter-spacing: 1px;

  h1 {
    // text-transform: uppercase;
    font-family: 'Geomanist';
    // letter-spacing: 1px;
    // color: $c-dark-blue;
    font-size: 40px;
    font-weight: 700;
  }

  h2 {
    //  text-transform: uppercase;
    font-family: 'Geomanist';
    // letter-spacing: 1px;
    // color: $c-mediumdark-gray;
    font-size: 25px;
  }

  h3 {
    //text-transform: uppercase;
    font-family: 'Geomanist';

    color: $c-dark-gray;
    font-size: 20px;
  }

  /*
  input[type='text'],
  input[type='password'],
  textarea {
    width: 100%;
    display: inline-block;
    transition: all 0.2s;
    border-radius: 0;
    background-color: $c-light-gray;
    border: 1px solid $c-dark-gray;
    color: $c-dark-grey;
    padding: 10px;
    padding-left: 15px;
    padding-right: 15px;
    outline: none;
  }
  */

  textarea {
    padding: 10px 15px;
    filter: none;
    //background-color: transparent !important;
    background: #fff;

    display: block;
    width: 100%;
    min-height: 150px;

    //border-top: 2px solid $c-white;
    //border-bottom: 2px solid $c-white;
    border: 1px solid $c-dark-grey;
    //color:#fff;
    letter-spacing: 1px;
    //font-weight: 700;
    &:focus {
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
      outline: none;
    }
  }

  .smalltext {
    text-align: center;
    font-size: 12px;
  }
  /*
  .form-element {
    label {
      background-color: none;
      text-transform: uppercase;
      font-size: 16px;
    }
  }
  */

  // .row {
  //   border: 1px solid blue;
  //   & > div {
  //     border: 1px solid red;
  //   }
  // }
}
</style>
